import { CalendarLarge } from '../../../assets/icons/CalendarLarge';
import { Dollar } from '../../../assets/icons/Dollar';
import { Phone } from '../../../assets/icons/Phone';
import { Placeholder } from '../../../assets/icons/Placeholder';
import { ReactNode } from 'react';
export type ChooseApplianceCareArticleProps = {
  icon: ReactNode;
  description: string;
  key?: number;
};

export const chooseApplianceCareArticles: ChooseApplianceCareArticleProps[] = [
  {
    icon: CalendarLarge(),

    description: 'Easy to schedule repairs at a time that works for you',
  },
  {
    icon: Placeholder(),
    description: 'Nationwide network of authorized technicians, using certified parts',
  },
  {
    icon: Dollar(),
    description: 'All parts and labor included, with zero deductibles',
  },
  {
    icon: Phone(),
    description: 'US-based Customer Care Center when you need help',
  },
];
